import { getCardFromCompiledRcs } from './rcsConfigToCardContent';
import { MAX_CARD_TITLE_LENGTH, MAX_DESCRIPTION_LENGTH } from './validateRcsConfig';

/** Length check result for compiled RCS card title and description vs editor max lengths. */
export interface CompiledRcsPreviewLimitResult {
  titleOverLimit: boolean;
  descriptionOverLimit: boolean;
  titleLength: number;
  descriptionLength: number;
}

/**
 * Parses compiled preview JSON and compares card title/description lengths to
 * {@link MAX_CARD_TITLE_LENGTH} and {@link MAX_DESCRIPTION_LENGTH}.
 * @returns `null` if JSON is invalid or has no card; otherwise flag + lengths.
 */
export function checkCompiledRcsPreviewLimits(compiledJson: string): CompiledRcsPreviewLimitResult | null {
  const card = getCardFromCompiledRcs(compiledJson);
  if (!card) return null;

  const titleLength = (card.title ?? '').length;
  const descriptionLength = (card.text ?? '').length;

  return {
    titleOverLimit: titleLength > MAX_CARD_TITLE_LENGTH,
    descriptionOverLimit: descriptionLength > MAX_DESCRIPTION_LENGTH,
    titleLength,
    descriptionLength,
  };
}
